import {
  IonContent,
  IonPage,
  useIonViewWillLeave,
  IonModal,
  IonButton,
  IonItem,
  IonInput,
  IonLabel,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { StorageService, utilService } from "../../services";
import StatusBoardDataTable from "./components/StatusBoardTable/StatusBoardTable";
import { statusBoardService } from "./StatusBoard.service";
import "./StatusBoard.scss";
import { statusBoardSocketService } from "./StatusBoardSocketService";
import { CONSTANTS } from "../../constants";
import CareTeam from "./components/CareTeam/CareTeam";
import Loader from "../../components/Shared/Loader/Loader";
import { useHistory, useLocation } from "react-router-dom";
import SupportStaff from "./components/SupportStaff/SupportStaff";
import classNames from "classnames/bind";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { useToast } from "@agney/ir-toast";
import SaCPatientListDropDown from "../../components/Shared/StartACasePatientList/StartACasePatientList";
import SelectCaseType from "../../components/Shared/SelectCaseTypes/SelectCaseType";
import { PatientFormService } from "../PatientForm/PatientForm.service";

const StatusBoardMainPage: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation("statusBoard");
  const { t: tHeader } = useTranslation("header");
  const Toast = useToast();
  const currentTime = new Date();
  const [isLoaderActive, setLoaderStatus] = useState(false);
  const [unitDetails, setUnitDetails] = useState<any>([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [statusBoardColumnUpdate, setStatusBoardColumnUpdate] = useState(false);

  const [params, setAPIParams] = useState({
    StatusBoardId: location.pathname?.split("/")[3],
    page: 1,
    hour: currentTime.getHours(),
    minute: currentTime.getMinutes(),
    reg_code: utilService.getNetwork(),
  });

  // Emergency button + its patient-select / case-type / sign-in confirm flow
  // -- moved here from Header.tsx's status-board-only header, which was a
  // redundant second nav bar now that the sidebar is always visible.
  const [selectPatient, isSelectPatient] = useState(false);
  const [patientsList, setPatientList] = useState<any>([]);
  const [selectedPatientId, setSelectedPatient] = useState();
  const [isPatientInEmergency, checkPatientInEmergency] = useState(false);
  const [EMTTypes, getEMTTypes] = useState([]);
  const [isCustomType, enableCustomType] = useState(false);
  const [selectedType, setSelectedType] = useState<any>(0);
  const [selectedTypeName, setSelectedTypeName]: any = useState();
  const [showSignInAlert, setShowSignInAlert] = useState(false);
  const [userName, setUserName] = useState<string>("");
  const [isInvalidCredentials, setSignInValidations] = useState(false);
  const [isShowPassword, setPasswordStatus] = useState(false);
  const [userPassword, setUserPassword] = useState<string>("");
  const [isFormValid, setFormStatus] = useState(false);
  const [showSelectProviderModal, setShowSelectProviderModal]: any =
    useState(false);
  const [selectedProvidersNames, setSelectedProvidersNames] = useState([]);
  const [selectedCaseTypeList, setSelectedCaseTypeList]: any = useState([]);
  const [disableAddButton, setDisableAddButton] = useState(true);
  const [signInErrorMessage, setSignInErrorMessage] = useState("");

  useEffect(() => {
    setFormStatus(formValidation());
  }, [userName, userPassword]);

  useEffect(() => {
    getTypesList();
  }, []);

  const formValidation = () => {
    return userName && userPassword ? true : false;
  };

  const enableEmergencyButton = () => {
    isSelectPatient(true);
    getStatusBoardPatientList();
    setSelectedProvidersNames([]);
    enableCustomType(false);
    setSelectedTypeName("");
  };

  const getStatusBoardPatientList = async () => {
    let apiParams = {
      StatusBoardId: location.pathname?.split("/")[3],
      page: 1,
      hour: currentTime.getHours(),
      minute: currentTime.getMinutes(),
      reg_code: utilService.getNetwork(),
    };
    const getTypesList: any = await statusBoardService.statusBoardPatients(
      apiParams
    );
    if (getTypesList.isSuccess) {
      var patientList = getTypesList.displayNotesCard.result;
      setPatientList(patientList);
    }
  };

  const UpdateSelectedPatientType = (selectedType: any) => {
    setSelectedPatient(selectedType);
    let patientData = patientsList.find(
      (patientName: { patient_id: any; name: any }) =>
        patientName.patient_id === selectedType
    );
    checkPatientInEmergency(patientData.added_to_emergency);
    if (selectedType && selectedProvidersNames.length !== 0) {
      setDisableAddButton(false);
    } else {
      setDisableAddButton(true);
    }
  };

  const setCustomCaseType = (selectedCase: any) => {
    setSelectedType(0);
    setSelectedTypeName(selectedCase.target.value);
  };

  const onShowPassword = () => {
    setPasswordStatus(!isShowPassword);
  };

  const getTypesList = async () => {
    const getTypesList: any = await PatientFormService.getTypesList(params);
    if (getTypesList.isSuccess) {
      getEMTTypes(getTypesList.result);
    }
  };

  const addPatientToEmergency = () => {
    const addParams: any = {
      reg_code: utilService.getNetwork(),
      patient_id: selectedPatientId,
      in_patient: true,
      case_type_list: selectedCaseTypeList,
      case_type_name: selectedTypeName,
      action_username: userName,
      action_password: userPassword,
    };

    inPatientEmergency(addParams);
  };

  async function inPatientEmergency(addParams: any) {
    const respTimer: any = await statusBoardService.inPatientEmergency(
      addParams
    );
    if (respTimer.isSuccess) {
      Toast.success("Patient added to emergency");
      setShowSignInAlert(false);
      enableRedirect();
      setUserName("");
      setUserPassword("");
      setSignInErrorMessage("");
    } else {
      statusBoardService.handleErrorResponse();
      setSignInValidations(true);
      setSignInErrorMessage(respTimer?.message || "Something went wrong");
    }
  }

  const enableRedirect = () => {
    history.push({
      pathname: "/client/case-history",
      state: { patientId: selectedPatientId, inPatient: true },
    });
  };

  const getSelectedProvidersList = (CaseListArrayList: any) => {
    let caseTypeIds = CaseListArrayList.map((item: any) => {
      if (item.is_selected === true) {
        return item.id;
      }
    });

    let caseTypeNames = CaseListArrayList.map((item: any) => {
      if (item.is_selected === true) {
        return item.case;
      }
    });

    let caseLists = caseTypeIds.filter(function (element: any) {
      return element !== undefined;
    });

    let caseNameLists = caseTypeNames.filter(function (element: any) {
      return element !== undefined;
    });

    setSelectedCaseTypeList(caseLists);
    checkOtherCaseTypeSelected(caseLists);
    setSelectedProvidersNames(caseNameLists);
    if (selectedPatientId && caseNameLists.length !== 0) {
      setDisableAddButton(false);
    } else {
      setDisableAddButton(true);
    }
  };

  const checkOtherCaseTypeSelected = (caseTypeList: any) => {
    const isOtherSelected = caseTypeList.includes(0);
    enableCustomType(isOtherSelected);
  };

  let primaryMdTimeOutArray: any = [];
  let NurseListTimeOutArray: any = [];

  useEffect(() => {
    primaryMdTimeOutArray.forEach((element: any) => {
      clearTimeout(element);
    });
    primaryMdTimeOutArray = [];

    NurseListTimeOutArray.forEach((element: any) => {
      clearTimeout(element);
    });
    NurseListTimeOutArray = [];
  }, []);

  useIonViewWillLeave(() => {
    statusBoardService.rowData = undefined;
    statusBoardService.statusBoardId = "";
    statusBoardSocketService.closeSbSocketConnection();
    statusBoardService.selectedStatusBoardData = undefined;
    statusBoardService.selectedRowId = "";
    const local_keys = ["currentStatusBoardId"];
    StorageService.removeStorageItem(localStorage, local_keys);
    setInitialLoading(true);
  });

  useEffect(() => {
    if (
      location.pathname.includes("/client/status-board") &&
      StorageService.getStorageItem(localStorage, "currentStatusBoardId") !== ""
    ) {
      getUnitDetails();
    }
    return () => {
      statusBoardService.rowData = undefined;
      statusBoardService.statusBoardId = "";
      statusBoardSocketService.closeSbSocketConnection();
      statusBoardService.selectedStatusBoardData = undefined;
      statusBoardService.selectedRowId = "";
      const local_keys = ["currentStatusBoardId"];
      StorageService.removeStorageItem(localStorage, local_keys);
      setInitialLoading(true);
    };
  }, [StorageService.getStorageItem(localStorage, "currentStatusBoardId")]);

  const getUnitDetails = async (isUpdate: boolean = false) => {
    setUnitDetails([]);
    setLoaderStatus(true);
    let unitListParams = getUnitListApiParams(isUpdate);
    const respResult: any = await statusBoardService.getUnitDetails(
      unitListParams
    );
    if (respResult) {
      setInitialLoading(false);
      const socketParams = {
        sbId: params.StatusBoardId,
      };
      statusBoardSocketService.getStatusBoardSocketConnection(
        CONSTANTS.SOCKET_PATH.CARE_TEAM,
        socketParams
      );
    }
    if (respResult.isSuccess) {
      setLoaderStatus(false);
      setUnitDetails(_.cloneDeep(respResult.unitList));
      setAllPrimaryMdShiftTimes(respResult.unitList);
      setAllNurseShiftTimes(respResult.unitList);
      statusBoardService.statusBoardData = respResult.unitList;
      statusBoardService.statusBoardId = params.StatusBoardId;
      if (statusBoardService.isBedSwappedOrTransferredId) {
        statusBoardService.bedTransferSwap();
      }
    } else {
      setLoaderStatus(false);
    }
  };

  const setAllPrimaryMdShiftTimes = (unitList: any) => {
    const getTime = new Date().toTimeString();
    const formatTime = getTime.slice(0, 8);
    const currentTime = formatTime.split(":");
    const getTimeInputData = currentTime[0] + ":" + currentTime[1];
    var shiftEndTimeArray: any = [];
    if (!_.isEmpty(unitList)) {
      unitList?.map((unitListItem: any) => {
        const bedList: any = unitListItem.bedList;
        bedList.map((bedListItem: any) => {
          if (!_.isEmpty(bedListItem.scrollable_columns)) {
            if (
              !_.isEmpty(bedListItem.scrollable_columns.primarymd.shift_time)
            ) {
              bedListItem.scrollable_columns.primarymd.shift_time.map(
                (shiftTime: any) => {
                  shiftEndTimeArray.push(shiftTime.end_time);
                }
              );
            }
          }
        });
      });
    }
    const uniqueEndTimeArray = Array.from(new Set(shiftEndTimeArray));
    const currentTimeInSec = formatTimeInSeconds(getTimeInputData);
    uniqueEndTimeArray.forEach((endTime: any) => {
      const reminder = formatAMPMtoSeconds(endTime);
      const timeDifference = reminder - currentTimeInSec;
      const formattedTimeDifference =
        timeDifference < 0 ? 86400 - timeDifference * -1 : timeDifference;

      let timeOut = setTimeout(() => {
        if (formattedTimeDifference != 0) {
          getUnitDetails(true);
        }
      }, formattedTimeDifference * 1000);

      const timeOutObject = {
        timeOutID: timeOut,
      };
      const isTimeOutObjectAlreadyAdded = _.find(primaryMdTimeOutArray, {
        timeOutID: timeOut,
      });
      if (!isTimeOutObjectAlreadyAdded) {
        primaryMdTimeOutArray.push(timeOutObject);
      }
    });
  };

  const setAllNurseShiftTimes = (unitList: any) => {
    const getTime = new Date().toTimeString();
    const formatTime = getTime.slice(0, 8);
    const currentTime = formatTime.split(":");
    const getTimeInputData = currentTime[0] + ":" + currentTime[1];
    var nurseShiftEndTimeArray: any = [];
    if (!_.isEmpty(unitList)) {
      unitList?.map((unitListItem: any) => {
        const bedList: any = unitListItem.bedList;
        bedList.map((bedListItem: any) => {
          if (!_.isEmpty(bedListItem.frozen_columns)) {
            if (!_.isEmpty(bedListItem.frozen_columns.nurse)) {
              const nurseList = bedListItem.frozen_columns.nurse.list_nurse;
              if (!_.isEmpty(nurseList)) {
                nurseList.map((nurse: any) => {
                  if (!_.isEmpty(nurse.shift_time)) {
                    nurse.shift_time.map((shiftTime: any) => {
                      nurseShiftEndTimeArray.push(shiftTime.end_time);
                    });
                  }
                });
              }
            }
          }
        });
      });
    }
    const uniqueEndTimeArray = Array.from(new Set(nurseShiftEndTimeArray));
    const currentTimeInSec = formatTimeInSeconds(getTimeInputData);
    uniqueEndTimeArray.forEach((endTime: any) => {
      const reminder = formatAMPMtoSeconds(endTime);
      const timeDifference = reminder - currentTimeInSec;
      const formattedTimeDifference =
        timeDifference < 0 ? 86400 - timeDifference * -1 : timeDifference;

      let timeOut = setTimeout(() => {
        if (formattedTimeDifference != 0) {
          getUnitDetails(true);
        }
      }, formattedTimeDifference * 1000);

      const timeOutObject = {
        timeOutID: timeOut,
      };
      const isTimeOutObjectAlreadyAdded = _.find(NurseListTimeOutArray, {
        timeOutID: timeOut,
      });
      if (!isTimeOutObjectAlreadyAdded) {
        NurseListTimeOutArray.push(timeOutObject);
      }
    });
  };

  const formatTimeInSeconds = (time: any) => {
    var array = time?.split(":");
    var timeInSeconds =
      parseInt(array[0], 10) * 60 * 60 + parseInt(array[1], 10) * 60 + 0;

    return timeInSeconds;
  };

  const formatAMPMtoSeconds = (timeValue: any) => {
    var splitByColon = timeValue.split(":");
    var hoursValue = parseInt(splitByColon[0]);
    var splitForMins = splitByColon[1].split(" ");
    if (splitForMins[1] === "PM") {
      hoursValue = hoursValue + 12;
    }
    var minutesValue = parseInt(splitForMins[0]);
    return 3600 * hoursValue + 60 * minutesValue;
  };
  const refreshTableData = () => {
    getUnitDetails();
    setStatusBoardColumnUpdate(true);
  };

  const getUnitListApiParams = (isUpdate: boolean) => {
    let apiInputs = {
      StatusBoardId: location.pathname?.split("/")[3],
      page: 1,
      hour: utilService.getCurrentHour(),
      minute: isUpdate
        ? utilService.getCurrentMinutes() + 1
        : utilService.getCurrentMinutes(),
      reg_code: utilService.getNetwork(),
    };

    return apiInputs;
  };

  const refreshCareTeamData = () => {
    // getCareTeamDetails();
  };

  return (
    <IonPage>
      <IonContent className="sb-content-cont">
        <div className="sb-toolbar-cont">
          <div
            className="emergency-button-section"
            onClick={() => {
              enableEmergencyButton();
            }}
          >
            {tHeader("emergency")}
          </div>
        </div>
        <div>
          {isLoaderActive && (
            <div
              className={classNames({
                "sb-loader-container": true,
                "datatable-loading": !initialLoading ? true : false,
              })}
            >
              <Loader></Loader>
            </div>
          )}
          <div className="top-section-container">
            {!(isLoaderActive && initialLoading) && (
              <div className="care-team">
                <CareTeam
                  statusBoardData={unitDetails}
                  updateTableData={refreshCareTeamData}
                  statusBoardId={params.StatusBoardId}
                ></CareTeam>
              </div>
            )}
            {!(isLoaderActive && initialLoading) && (
              <div className="support-staff">
                {" "}
                <SupportStaff
                  statusBoardData={unitDetails}
                  updateTableData={refreshCareTeamData}
                  statusBoardId={params.StatusBoardId}
                ></SupportStaff>
              </div>
            )}

            {!(isLoaderActive && initialLoading) && (
              <div className="status-board-table-cont">
                <StatusBoardDataTable
                  unitDetails={unitDetails}
                  statusBoardData={params}
                  updateTableData={refreshTableData}
                  tableColumnUpdate={statusBoardColumnUpdate}
                ></StatusBoardDataTable>
              </div>
            )}
          </div>
        </div>
      </IonContent>

      <IonModal
        isOpen={selectPatient}
        backdropDismiss={false}
        className="emergency-patient"
      >
        <div className="label-div">
          <div className="label-name">{tHeader("emergency")}</div>
        </div>

        <form className="case-details-edit-modal">
          <div className="form-row">
            <div className="col-md-12 mb-3">
              <label className="ems-form-label">{tHeader("selectPatient")}</label>
              <SaCPatientListDropDown
                ListData={patientsList}
                getSelectedItem={(value: number) => {
                  UpdateSelectedPatientType(value);
                }}
              ></SaCPatientListDropDown>
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-12 mb-3">
              <label className="ems-form-label">{tHeader("selectCaseTypes")}</label>
              <IonItem className="select-schedule-wrapper">
                <IonInput
                  readonly
                  className="schedule-input"
                  onClick={() => setShowSelectProviderModal(true)}
                  value={
                    selectedProvidersNames[0] === "ALL" ||
                    selectedProvidersNames.length === 0
                      ? tHeader("selectCaseTypes")
                      : selectedProvidersNames.join()
                  }
                ></IonInput>
              </IonItem>

              <SelectCaseType
                showModal={showSelectProviderModal}
                onOk={() => {
                  setShowSelectProviderModal(false);
                }}
                ListData={EMTTypes}
                isAllSelected={false}
                onCancel={() => {
                  setShowSelectProviderModal(false);
                }}
                getSelectedProviders={getSelectedProvidersList}
                isFromStatusboard={true}
              />
            </div>
            <div className="col-md-12 mb-3" hidden={!isCustomType}>
              {isCustomType && (
                <>
                  <label className="ems-form-label">{tHeader("otherCaseType")}</label>

                  <input
                    type="text"
                    className="form-control custom-type emt-sac-input"
                    id="field-1"
                    maxLength={26}
                    placeholder={tHeader("enterOtherCaseType")}
                    value={selectedTypeName}
                    onChange={(selectedCase: any) =>
                      setCustomCaseType(selectedCase)
                    }
                  />
                </>
              )}
            </div>
          </div>
        </form>

        <div className="add-fav-button-container">
          <div className="cancel-button-div sign-in-btn">
            <IonButton
              color="medium"
              className="button secondary-btn  btn-curved"
              onClick={() => {
                isSelectPatient(false);
                setSelectedPatient(undefined);
                setSelectedCaseTypeList([]);
                setSelectedProvidersNames([]);
              }}
            >
              {tHeader("cancel")}
            </IonButton>
          </div>
          <div className="send-button-div sign-in-btn">
            <IonButton
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                if (!isPatientInEmergency) {
                  isSelectPatient(false);
                  setShowSignInAlert(true);
                } else {
                  Toast.error(tHeader("patientAlreadyInEmergency"));
                }
              }}
              disabled={disableAddButton}
            >
              {tHeader("add")}
            </IonButton>
          </div>
        </div>
      </IonModal>

      <IonModal
        isOpen={showSignInAlert}
        backdropDismiss={false}
        className="add-fav-modal sb-fav-modal sign-In-modal"
      >
        <div className="label-div">
          <div className="label-name">{tHeader("signIn")}</div>
          <div
            className="input-icon icon-close"
            onClick={() => {
              setShowSignInAlert(false);
              setUserName("");
              setUserPassword("");
            }}
          ></div>
        </div>
        <form className="sign-in-input-container" autoComplete="off">
          <div className="signin-input-wrapper">
            <IonItem className="item-input">
              <IonLabel className="item-label" position="floating">
                {tHeader("username")}
              </IonLabel>
              <IonInput
                className="ion-input"
                name="username"
                type="search"
                value={userName}
                onIonChange={(event) => {
                  setUserName(event.detail.value!);
                  setSignInValidations(false);
                  setSignInErrorMessage("");
                }}
                autocomplete="off"
                maxlength={25}
              >
                {" "}
              </IonInput>
            </IonItem>
          </div>
          <div className="signin-input-wrapper">
            <div
              className={`input-icon clickable ${
                isShowPassword ? "icon-show_password" : "icon-hide_password"
              }`}
              onClick={onShowPassword}
            ></div>
            <IonItem className="item-input">
              <IonLabel className="item-label" position="floating">
                {tHeader("password")}
              </IonLabel>
              <IonInput
                className="ion-input"
                type={isShowPassword ? "text" : "password"}
                name="password"
                value={userPassword}
                onIonChange={(event) => {
                  setUserPassword(event.detail.value!);
                  setSignInValidations(false);
                  setSignInErrorMessage("");
                }}
                autocomplete="new-password"
              >
                {" "}
              </IonInput>
            </IonItem>
          </div>
          <div className="signin-validations" hidden={!isInvalidCredentials}>
             {signInErrorMessage}
          </div>
        </form>

        <div className="add-fav-button-container">
          <div className="cancel-button-div sign-in-btn">
            <IonButton
              color="medium"
              className="button secondary-btn  btn-curved"
              onClick={() => {
                setUserName("");
                setUserPassword("");
              }}
            >
              {tHeader("clear")}
            </IonButton>
          </div>
          <div className="send-button-div sign-in-btn">
            <IonButton
              disabled={!isFormValid}
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                addPatientToEmergency();
              }}
            >
              {tHeader("signIn")}
            </IonButton>
          </div>
        </div>
      </IonModal>
    </IonPage>
  );
};

export default StatusBoardMainPage;
